export const Locales = {
  EN_US: 'en-us',
};
